module.exports = __webpack_public_path__ + "img/background_19.b0af1a0a.jpg";